// @flow

import React, { type Node, useEffect } from 'react';
import { useSubmitting } from '@tectonics/prs/submitting';
import { Label, Select, Option } from '../../../../../../commons/atoms';
import { InputGroup } from '../../../../../../commons/molecules';
import { useUserInputAsSelect, useUserInputValue } from '@tectonics/prs/user-input-values';
import { useMustShow, useUniqueId } from '@tectonics/hooks';
import { useUserInputValidationError, type UserInputValidationError } from '@tectonics/prs/validation';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { ErrorLabel } from '../../commons';

export function InputArgentineDocumentType(): Node {
  const [value, handleChange] = useUserInputAsSelect('argentineDocumentType');
  const [, setDocument] = useUserInputValue('argentineDocument');
  const submitting = useSubmitting();
  const mustShow = useMustShow('argentineDocument');
  const inputId = useUniqueId();

  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('argentineDocumentType');

  useEffect(() => {
    setDocument('');
  }, [setDocument, value]);

  if (!mustShow)
    return null;

  return (
    <div data-test-name="customer-document-type">
      <InputGroup
        label={<Label htmlFor={inputId}>Tipo de identificación</Label>}
        input={
          <Select
            id={inputId}
            value={value}
            onChange={handleChange}
            readOnly={submitting}
            fashion={formHasBeenSent && validationError ? 'error' : null}
            data-error={formHasBeenSent && validationError ? 'error' : null}
            name="customer-document-type"
          >
            <Option value="">Elige un documento</Option>

            {DOCUMENT_TYPES.map(document => (
              <Option key={document.code} value={document.code}>
                {document.name}
              </Option>
            ))}
          </Select>
        }
      />
      {formHasBeenSent && validationError && (
        <ValidationErrorMessage validationError={validationError} />
      )}
    </div>
  );
}

const DOCUMENT_TYPES = [
  { code: 'DNI', name: 'DNI' },
  { code: 'CUIT', name: 'CUIT' },
  { code: 'CUIL', name: 'CUIL' },
  { code: 'CDI', name: 'CDI' },
];

type ValidationErrorMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationErrorMessage({ validationError }: ValidationErrorMessageProps): Node {
  switch (validationError.id) {
    case 'empty':
      return <ErrorLabel>Seleccione el tipo de identificación</ErrorLabel>;
    default:
      return <ErrorLabel>Tipo de identificación inválido</ErrorLabel>;
  }
}
